import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { selectActiveDivergenceId } from 'src/features/divergence-demands/DivergenceDemandsSelector'
import BadgeInput from '../../components/BadgeInput/BadgeInput'
import Header from 'src/features/restocking/components/RestockingWebAppForm/components/Header/Header'
import * as S from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page.styles'

const DivergenceBadgePage: React.FC = () => {
  const activeDivergenceId = useSelector(selectActiveDivergenceId)
  const history = useHistory()

  useEffect(() => {
    if (!activeDivergenceId) {
      history.push('/restocking/divergence')
    }
  }, [activeDivergenceId, history])

  return (
    <S.PageContainer>
      <Header
        title='Divergência'
        goBackRoute='/restocking/divergence'
        hasBackButton
      />
      <BadgeInput />
    </S.PageContainer>
  )
}

export default DivergenceBadgePage
